import React from 'react'

export default function PageNotFound() {
    return (
        <>
        <h2>This page does not exist!</h2>
        </>
    )
}